import reconciliationConsts from './reconciliation/index';

export default function commonConstant(app) {
	app.constant('RECONCILIATION_CONSTANTS', reconciliationConsts);
}
